import React from 'react';
import { upperFirst } from 'lodash';
import { Icon } from 'Components/frameworks/icon/Icon';
type Props = {
  className?: string;
  status: GreatMembersStatus;
  width?: string;
};
export const GreatMembersIcon = ({ className, status, width = '4rem' }: Props) => (
  <Icon
    className={className}
    isNotMonoChrome
    isNotSquare
    name={`GreatMembers${upperFirst(status)}`}
    width={width}
  />
);
